/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Arun's Portfolio",
  description:
    "Innovative software developer with a diverse skill set spanning web service development, deep learning, and cloud computing. Proficient in Python-based MPI development, ",
  og: {
    title: "Arun Jose Portfolio",
    type: "website",
    url: "http://arunjose696.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Arun Jose",
  logo_name: "ArunJose",
  nickname: "Sudo Arun Jose",
  subTitle:
    "Innovative software developer with a diverse skill set spanning web service development, deep learning, and cloud computing. Proficient in Python-based MPI development",
  resumeLink:
    "https://drive.google.com/file/d/1zxgplLLOD5r0ZOgo6oO1MtalT-TkLamA/view?usp=sharing",
  portfolio_repository: "https://github.com/arunjose696/masterPortfolio",
  githubProfile: "https://github.com/arunjose696",
};

const socialMediaLinks = [
  
  {
    name: "Github",
    link: "https://github.com/arunjose696",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/arun-jose-6055561a1/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:arunjose696@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  
  {
    name: "Stack Overflow",
    link: "https://stackoverflow.com/users/12023442/arunjose",
    fontAwesomeIcon: "fa-stack-overflow", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];
const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg", 
      skills: [
        "Proficient in Python, Node.js, JavaScript, React, and various frameworks.",
        "Experience with backend development (FastAPI, Express.js, Flask).",
        "Developed web applications, mobile apps, and voice user interfaces.",
        "Contributed to large-scale open-source projects (Modin, Unidist).",
        "Experience with RESTful APIs, Microservices, and database integrations (SQL, NoSQL).",
        "Proficient in version control systems (Git, SVN).",
        "Experience with Agile development methodologies.",

      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#000000", color: "#F7DF1E" },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
          style: { color: "#1572B6" },
        },
        { skillName: "Git", fontAwesomeClassname: "simple-icons:github", style: { color: "#181717" } },
        { skillName: "NPM", fontAwesomeClassname: "simple-icons:npm", style: { color: "#CB3837" } },
        { skillName: "Yarn", fontAwesomeClassname: "simple-icons:yarn", style: { color: "#2C8EBB" } },
        { skillName: "Docker", fontAwesomeClassname: "simple-icons:docker", style: { color: "#1488C6" } },
        { skillName: "Kubernetes", fontAwesomeClassname: "simple-icons:kubernetes", style: { color: "#326CE5" } },
        { skillName: "AWS", fontAwesomeClassname: "simple-icons:amazonaws", style: { color: "#FF9900" } },
        { skillName: "GCP", fontAwesomeClassname: "simple-icons:googlecloud", style: { color: "#4285F4" } },
        { skillName: "PostgreSQL", fontAwesomeClassname: "simple-icons:postgresql", style: { color: "#336791" } },
        { skillName: "MongoDB", fontAwesomeClassname: "simple-icons:mongodb", style: { color: "#47A248" } },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg", 
      skills: [
        "Experience with AWS (EC2, Lambda, S3) and GCP (Compute Engine, Cloud Functions, Cloud Storage).",
        "Proficient in Docker, Kubernetes, and CI/CD pipelines (GitHub Actions, Jenkins).",
        "Infrastructure as Code (IaC) using Terraform and Ansible.",
        "Experience with monitoring and logging tools (CloudWatch, Stackdriver, Prometheus).",
        "Experience with serverless architectures.",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: { color: "#4285F4" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "simple-icons:terraform",
          style: { color: "#43826A" },
        },
        {
          skillName: "Ansible",
          fontAwesomeClassname: "simple-icons:ansible",
          style: { color: "#000000" },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:github",
          style: { color: "#181717" },
        },
      ],
    },
    {
      title: "AI & Machine Learning",
      fileName: "AIMLImg", 
      skills: [
        "Expertise in Deep Learning frameworks (PyTorch, TensorFlow, Keras).",
        "Experience with Natural Language Processing (NLP) and LLMs (GPT-3, BERT).",
        "Developed and deployed machine learning models to production using various cloud platforms.",
        "Experience with various AI tools and libraries (Pandas, NumPy, scikit-learn, OpenCV).",
        "Experience with model optimization and deployment strategies.",
        "Familiar with various Machine Learning algorithms (Regression, Classification, Clustering).",
        "Experience with building and training custom models using large datasets.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { color: "#3776AB" },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: { color: "#FF6F00" },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: { color: "#EA4723" },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: { color: "#D00000" },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: { color: "#150050" },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: { color: "#000000" },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: { color: "#000000" },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: { color: "#000000" },
        },
      ],
    },
    {
      title: "Other Skills",
      fileName: "OtherSkillsImg", 
      skills: [
          "Proficient in MPI programming for parallel computing.",
          "Experience with database technologies (SQL, MongoDB, Redis, DynamoDB).",
          "Experience with message queues (Kafka, RabbitMQ).",
          "Experience with various operating systems (Linux, Windows, Android).",
          "Experience with building and deploying applications using various cloud platforms.",
          "Strong understanding of software engineering principles (SOLID, DRY, KISS).",
          "Experience with various design patterns (MVC, MVVM, Singleton).",
          "Good communication skills, both written and verbal.",
          "Strong problem-solving skills and a willingness to learn new things.",
          "Experience working in a team environment.",
          "Experience with Agile development methodologies (Scrum, Kanban).",

      ],
      softwareSkills: [
          {
            skillName: "MPI",
            fontAwesomeClassname: "simple-icons:mpi",
            style: { color: "#000000" },
          },
          {
            skillName: "SQL",
            fontAwesomeClassname: "simple-icons:sql",
            style: { color: "#000000" },
          },
          {
            skillName: "MongoDB",
            fontAwesomeClassname: "simple-icons:mongodb",
            style: { color: "#47A248" },
          },
          {
            skillName: "Redis",
            fontAwesomeClassname: "simple-icons:redis",
            style: { color: "#DC3522" },
          },
          {
            skillName: "DynamoDB",
            fontAwesomeClassname: "simple-icons:amazonaws",
            style: { color: "#FF9900" },
          },
          {
            skillName: "Kafka",
            fontAwesomeClassname: "simple-icons:apachekafka",
            style: { color: "#000000" },
          },
          {
            skillName: "RabbitMQ",
            fontAwesomeClassname: "simple-icons:rabbitmq",
            style: { color: "#000000" },
          },
          {
            skillName: "Linux",
            fontAwesomeClassname: "simple-icons:linux",
            style: { color: "#000000" },
          },
          {
            skillName: "Windows",
            fontAwesomeClassname: "simple-icons:windows",
            style: { color: "#0078D7" },
          },
          {
            skillName: "Android",
            fontAwesomeClassname: "simple-icons:android",
            style: { color: "#A4C639" },
          },

      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/arunjose696/",
    },
    
  ],
};

const degrees = {
  degrees: [
    {
      title: "Master of Science in Digital Engineering",
      subtitle: "Otto von Guericke University Magdeburg",
      logo_path: "ovgu.jpg", 
      alt_name: "OVGU",
      duration: "2022-Present",
      descriptions: [
        "Focus: Data Mining, Databases, Software Testing, Conversational AI, Usability Analysis",
        "Thesis: Development of an LLM-based voice user interface with end-of-turn detection.",
      ],
      website_link: "https://www.ovgu.de/en.html",
    },
    // Add other degrees here following the same structure
    {
        title: "Bachelor of Technology in Mechanical Engineering",
        subtitle: "VIT Vellore", // Replace with your university name
        logo_path: "vit.png", // Replace with actual path
        alt_name: "[University Abbreviation]", // Replace with abbreviation
        duration: "2013-2017",
        descriptions: [
          "Relevant coursework included areas like Manufacturing Processes, Thermodynamics, Fluid Mechanics etc."
        ],
        website_link: "https://www.vit.ac.in", // Replace with URL
      },
  ],
};

const certifications = {
  certifications: [
    {
      title: "aws certified developer associate",
      subtitle: "AWS",
      logo_path: "aws.png",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    }
    
   
    
    
  ],
};

const experience = {
  title: "Experience",
  subtitle: "Work and Academic Experience", // More accurate than "Work, Internship and Volunteership" based on resume
  description: null, // Removed generic description; details are in individual entries
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Professional Experience",
      work: true,
      experiences: [
        {
          title: "Working Student Software Developer",
          company: "INTEL",
          company_url: null, // Add URL if available
          logo_path: "intel_logo.jpg",
          duration: "October 2022 - Present",
          location: "Munich, Germany",
          description:
            "Contributed to Intel's open-source Dataframes stack (Modin, Unidist), optimizing data processing and improving benchmark timings. Automated AWS deployment using IaC, reducing setup time. Accelerated Unidist performance by adding C++ code with Python wrappers. Authored a blog post on scaling DataFrame processing.",
          color: "#000000", // Choose appropriate color
        },
        {
          title: "Technical Solution Engineer AI",
          company: "TCS",
          company_url: null, // Add URL if available
          logo_path: "TCS.jpg", // Replace with TCS logo path
          duration: "March 2022 - June 2018", // This range seems unusual; review dates
          location: "Kochi, India",
          description:
            "Optimized AI workloads for startups, reducing inference latency. Developed high-performance AI solutions using Intel-optimized frameworks. Provided solutions to community problems using Intel software products. Automated Linux deployments with Ansible. Built AI prototypes, including chatbots.",
          color: "#0070C0", // Example color, adjust as needed
        },
        {
          title: "Web Service Developer",
          company: "TCS (American Express Project)",
          company_url: null, // Add URL if available
          logo_path: "TCS.jpg", // Replace with TCS logo path
          duration: "April 2017 - May 2018",
          location: "Kochi, India",
          description:
            "Developed and deployed high-impact SOAP/REST web services on IBM DataPower.  Used Docker, Kubernetes, Kafka, and PostgreSQL. Engineered and containerized Java and JavaScript microservices, deploying them to Kubernetes. Designed and built robust RESTful APIs using Swagger.",
          color: "#0070C0", // Example color, adjust as needed
        },
      ],
    },
    {
      title: "Academic Experience", // Replacing "Internships" as most roles seem academic-related
      experiences: [
        {
          title: "Wissenschaftliche Hilfskraft AI",
          company: "Otto-von-Guericke-University",
          company_url: null, // Add URL if available
          logo_path: "ovgu.jpg", // Replace with OVGU logo path
          duration: "September 2022 - May 2022",
          location: "Magdeburg, Germany",
          description:
            "Refactored an explainable AI toolbox, improving code readability and maintainability. Fixed critical bugs and implemented port forwarding. Developed abstractions for consistent visualization of AI models across frameworks (PyTorch, TensorFlow, Keras).",
          color: "#0070C0", // Example color, adjust as needed
        },
      ],
    },
    // Consider removing the "Volunteerships" section if these are not significant professional experiences.  If kept, adapt descriptions to fit this professional context.
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create AI based projects  using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published  Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "modin-blog-post",
      name: "Blog Post on Scaling Modin on Ray",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://dchigarev.github.io/modin_perf_examples/gh_page_4.html",
    },
    {
      id: "EGR",
      name: "Influence of injection timing and exhaust gas recirculation (EGR)",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://link.springer.com/article/10.1007/s11356-019-05369-7",
    },
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "arun.jpg", // Replace with Arun's image
    description:
      "I am available to connect.  Feel free to reach out; I aim to respond within 24 hours. My expertise includes ML, AI, web development, Android, cloud technologies, and open-source contributions.", // More concise and professional
  },
  blogSection: {
    title: "Website currently developed", // Singular is better
    subtitle: "My current hobby, Influencer review", // More concise
    link: "https://creative-swan-6e4320.netlify.app/", //  Leave null initially, and populate once Arun's blog URL is available.
    avatar_image_path: "blogs_image.svg", // Consider a more descriptive name
  },
  addressSection: {
    title: "Location", // More neutral than "Address"
    subtitle: null, // Remove unless a specific address is publicly available. Privacy is important.
    // locality, country, region, postalCode, streetAddress are removed for privacy.
    avatar_image_path: "location_icon.svg", // Consider a map icon
    location_map_link: null, // Remove unless a map link is relevant and appropriate
  },
  socialMediaSection: { // New section for social links
    title: "Connect With Me",
    links: [
      {
        platform: "LinkedIn",
        url: "https://www.linkedin.com/in/arun-jose-6055561a1", // From resume
        icon: "linkedin.svg",
      },
      {
        platform: "GitHub",
        url: "https://github.com/arunjose696", // From resume
        icon: "github.svg",
      },
      {
        platform: "Stack Overflow",
        url: "https://stackoverflow.com/users/12023442/arunjose", // From resume
        icon: "stackoverflow.svg",
      },
      // Add other social media links here as needed
    ],
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+49 17657835788", // From resume - Consider privacy implications
  },
  emailSection: { // New section for email
    title: "Email",
    subtitle: "arunjose696@gmail.com", // From resume
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
